"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * ProductConverter.
 *
 * @author JMe
 */


var ProductConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(ProductConverter, _DataObjectConverter_);

  function ProductConverter() {
    _classCallCheck(this, ProductConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(ProductConverter).apply(this, arguments));
  }

  return ProductConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.ProductConverter = ProductConverter;